import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	showMoreButtonText: {
		id: 'jql-builder-basic-picker.async-select.menu-list.show-more-button.show-more-button-text',
		defaultMessage: 'Show more',
		description: 'Clicking this button will load more items into the dropdown',
	},
	showMoreButtonLabel: {
		id: 'jql-builder-basic-picker.async-select.menu-list.show-more-button.show-more-button-label',
		defaultMessage: 'Show more filter options',
		description: 'Label of the button that would show more filter options',
	},
});
